/*global angular:true, browser:true */

/**
 * @license HTTP Auth Interceptor Module for AngularJS
 * (c) 2012 Witold Szczerba
 * License: MIT
 */
(function () {
    "use strict";

    angular
        .module("http-auth-interceptor", ["http-auth-interceptor-buffer"])

        .factory("authService", [
            "$rootScope",
            "httpBuffer",
            function ($rootScope, httpBuffer) {
                return {
                    /**
                     * call this function to indicate that authentication was successfull and trigger a
                     * retry of all deferred requests.
                     * @param data an optional argument to pass on to $broadcast which may be useful for
                     * example if you need to pass through details of the user that was logged in
                     */
                    isLoggedIn: true,
                    loginConfirmed: function (data, configUpdater) {
                        var updater =
                            configUpdater ||
                            function (config) {
                                return config;
                            };
                        $rootScope.$broadcast("event:auth-loginConfirmed", data);
                        httpBuffer.retryAll(updater);
                    }
                };
            }
        ])

        /**
         * $http interceptor.
         * On 401 response (without 'ignoreAuthModule' option) stores the request
         * and broadcasts 'event:angular-auth-loginRequired'.
         */
        .config([
            "$httpProvider",
            function ($httpProvider) {
                var interceptor = [
                    "$rootScope",
                    "$q",
                    "httpBuffer",
                    "Global",
                    "AuthInfo",
                    "$window",
                    function ($rootScope, $q, httpBuffer, Global, AuthInfo, $window) {
                        return {
                            request: async function (request) {
                                if (request.method === "PUT") {
                                    $rootScope.$broadcast("putWasInitiated");
                                }

                                if (AuthInfo.LoggedInUser) {
                                    var api =
                                        AuthInfo.LoggedInUser.currentAccount.slug +
                                        "/" +
                                        AuthInfo.LoggedInUser.currentBrand.slug;
                                    request.url = request.url.format(api);
                                }

                                const token = await window.getAuthToken();
                                const bauUrl = $window["bau_url"];
                                const acUrl = $window["ac_url"];

                                if (token) {
                                    request.headers["Authorization"] = "Bearer " + token;
                                }

                                if (bauUrl && request.url.match(/api\/adminpanel/)) {
                                    request.url =
                                        bauUrl + (request.url.startsWith("/") ? "" : "/") + request.url;
                                } else if (acUrl && request.url.match(/accounts\/cleanups/)) {
                                    request.url =
                                        acUrl + (request.url.startsWith("/") ? "" : "/") + request.url;
                                }

                                return request;
                            },
                            response: function (response) {
                                if (response.config.method === "PUT") {
                                    if (response.status === 200 || response.status === 201) {
                                        $rootScope.$broadcast("putWasSuccessfull");
                                    }
                                }
                                return response;
                            },
                            responseError: function (response) {
                                if (response.status === 401 && !response.config.ignoreAuthModule) {
                                    var deferred = $q.defer();
                                    httpBuffer.append(response.config, deferred);
                                    $rootScope.$broadcast("event:auth-loginRequired");
                                    return deferred.promise;
                                } else if (
                                    response.status === 402 &&
                                    !response.config.ignoreAuthModule
                                ) {
                                    $rootScope.$broadcast("event:auth-noPermission");
                                    return false;
                                } else if (
                                    response.status === 423 &&
                                    !response.config.ignoreAuthModule
                                ) {
                                    $rootScope.$broadcast("event:auth-noFeature");
                                    return false;
                                } else if (response.status === 498) {
                                    $rootScope.$broadcast("event:auth-nopayment");
                                    return false;
                                } else if (response.status === 488) {
                                    window.location = "/AccessDenied";
                                    return false;
                                } else if (response.status === 496) {
                                    window.location =
                                        "/AccountDisabled?r=" + encodeURIComponent(response.data);
                                    return false;
                                } else {
                                    if (response.status === 500) {
                                        var responseHeaders = response.headers();
                                        var bannerFlowRequestId =
                                            responseHeaders["bannerflow-request-id"];
                                        $rootScope.$broadcast(
                                            "event:general-error",
                                            bannerFlowRequestId
                                        );
                                        return $q.reject(response);
                                    }

                                    if (response.config.method === "PUT") {
                                        $rootScope.$broadcast("putFailed");
                                    }
                                }

                                // otherwise, default behaviour
                                return $q.reject(response);
                            }
                        };
                    }
                ];

                //$httpProvider.responseInterceptors.push(interceptor);
                $httpProvider.interceptors.push(interceptor);
            }
        ]);

    /**
     * Private module, a utility, required internally by 'http-auth-interceptor'.
     */
    angular
        .module("http-auth-interceptor-buffer", [])

        .factory("httpBuffer", [
            "$injector",
            function ($injector) {
                /** Holds all the requests, so they can be re-requested in future. */
                var buffer = [];

                /** Service initialized later because of circular dependency problem. */
                var $http;

                function retryHttpRequest(config, deferred) {
                    function successCallback(response) {
                        deferred.resolve(response);
                    }
                    function errorCallback(response) {
                        deferred.reject(response);
                    }
                    $http = $http || $injector.get("$http");
                    $http(config).then(successCallback, errorCallback);
                }

                return {
                    /**
                     * Appends HTTP request configuration object with deferred response attached to buffer.
                     */
                    append: function (config, deferred) {
                        buffer.push({
                            config: config,
                            deferred: deferred
                        });
                    },

                    /**
                     * Retries all the buffered requests clears the buffer.
                     */
                    retryAll: function (updater) {
                        for (var i = 0; i < buffer.length; ++i) {
                            retryHttpRequest(updater(buffer[i].config), buffer[i].deferred);
                        }
                        buffer = [];
                    }
                };
            }
        ]);
})();
